import {ValidationMessage} from 'common';
import {SelectField, SelectFieldProps} from 'evergreen-ui';
import React, {memo} from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {isClinicRequired, Referral} from 'referral';
import {Observable} from 'rxjs';
import {useObservable} from 'rxsupport';
import {OfferFormInput} from './OfferForm';

type ServiceInClinicInputProps = {
    referral: Referral;
    isSubmitting$: Observable<boolean>;
    requireClinicLocationInput?: boolean;
} & SelectFieldProps;

export const ServiceInClinicInput = memo(({
                                              referral,
                                              isSubmitting$,
                                              requireClinicLocationInput = false,
                                              ...selectProps
                                          }: ServiceInClinicInputProps) => {
    const {
        control,

        formState: {
            errors,
        },
    } = useFormContext<OfferFormInput>();

    const sending = useObservable(isSubmitting$, false);

    return (
        <Controller
            name='provideServicesInClinic'
            control={control}
            rules={{
                required: {
                    value: isClinicRequired(referral),
                    message: 'This field is required.',
                },
            }}
            render={({field: {onChange, value}}) => {
                const props = {
                    maxWidth: '24em',
                    display: requireClinicLocationInput ? 'none' : 'block',
                    label: 'Can you provide services in a clinic settings',
                    ...selectProps,
                    onChange,
                    value: value ? value : undefined,
                    isInvalid: !!errors?.provideServicesInClinic?.message,
                    validationMessage: <ValidationMessage error={errors?.provideServicesInClinic}/>,
                    disabled: sending,
                }
                return (
                    <SelectField {...props}>
                        <option value=''/>
                        <option value='true'>Yes</option>
                        <option value='false'>No</option>
                    </SelectField>
                );
            }}
        />
    );
});
